import Alerts from '@rover/utilities/Alerts';

import $ from '@rover/globals/jquery';
import Backbone from '@rover/globals/backbone';
import Mustache from '@rover/globals/Mustache';
import _ from '@rover/globals/underscore';
import Rover from '@rover/globals/Rover';
import dataLayer from '@rover/globals/dataLayer';
import i18n from '@rover/utilities/translation';
import { t } from '@lingui/macro';

export default Backbone.View.extend({
  template: Mustache.template('new_design/account_conversations/redemption'),
  events: {
    'click .js-redeem': 'redeemCode',
    'change .js-redemption-code': 'toggleRedeem',
    'keyup .js-redemption-code': 'toggleRedeem',
  },
  initialize(options) {
    _.bindAll(this, 'redeemCode', 'toggleRedeem', 'showError');
    this.roverBucksModel = options.roverBucksModel;
    this.paymentMethodCollection = options.paymentMethodCollection;
    this.resetAttempts();
  },
  render() {
    this.$el.html(this.template.render({ conversation_opk: Rover.conversation_opk }));
  },
  toggleRedeem() {
    this.$('.js-redeem').prop('disabled', $.trim(this.$('.js-redemption-code').val()) === '');
  },
  showError(error) {
    Alerts.showToast({
      severity: 'danger',
      message: error,
      container: this.$('.js-redemption-alert-container'),
      showHideButton: false,
    });
  },
  showSuccess(data) {
    const message = i18n._(
      /* i18n: {0} will be a promo code name e.g ONEFREEGROOMING  */ t`Redeemed code ${data.code}!`
    );
    Alerts.showToast({
      severity: 'success',
      message,
      container: this.$('.js-redemption-alert-container'),
      showHideButton: false,
    });
  },
  redeemCode() {
    const redemptionCodeInputVal = $.trim(this.$('.js-redemption-code').val());
    const redemptionIntendedconversationOpkVal = $.trim(
      this.$('.js-redemption-intended-conversation-opk').val()
    );

    dataLayer.push({
      event: 'owner-conversion-checkout-promo-code',
      promoCode: redemptionCodeInputVal,
    });

    this.$('.js-redemption-alert-container').empty();
    const redemptionModel = new Rover.models.RedemptionModel();
    redemptionModel.set('code', redemptionCodeInputVal);
    redemptionModel.set('intended_conversation_opk', redemptionIntendedconversationOpkVal);
    this.disableForm();

    this.trySave(redemptionModel);
  },
  DELAYS: [0, 500, 1500],
  getDelay() {
    return this.DELAYS[this.attempts];
  },
  maxAttemptsExceeded() {
    return this.attempts >= this.DELAYS.length;
  },
  resetAttempts() {
    this.attempts = 0;
  },
  trySave(redemptionModel) {
    if (this.maxAttemptsExceeded()) {
      this.redemptionFailure(
        "We're unable to process the code at this time. Please try again shortly."
      );
      return;
    }

    setTimeout(() => {
      redemptionModel.save(null, {
        success: (model, data, options) => {
          if (options.xhr.status === 202) {
            this.attempts += 1;
            this.trySave(model);
            return;
          }

          this.redemptionSuccess(data);
        },
        error: (model, data) => {
          let error;
          if (data.responseJSON) {
            error = data.responseJSON.error_description;
          }

          this.redemptionFailure(error);
        },
      });
    }, this.getDelay());
  },
  redemptionSuccess(data) {
    this.$('.js-redemption-code')
      .val('')
      .trigger('change');
    this.paymentMethodCollection.fetch();

    this.showSuccess(data);
    this.enableForm();
    this.resetAttempts();
  },
  redemptionFailure(errorMessage = 'Error redeeming code') {
    this.showError(errorMessage);
    this.enableForm();
    this.resetAttempts();
  },
  enableForm() {
    this.$('.js-redemption-code').prop('disabled', false);
    this.$('.js-redeem').btn('reset');
  },
  disableForm() {
    this.$('.js-redemption-code').prop('disabled', true);
    this.$('.js-redeem').btn('loading');
  },
});



// WEBPACK FOOTER //
// ./js/backbone/views/checkout/redemption_view.js